import {
    getSubscriptionType,
    SubscriptionType,
} from '@thoughtspot/session-service';

/** Regex pattern for basic email validation (user@domain.tld). */
const validEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Validates whether the given string is a well-formed email address.
 *
 * @param email - The email address string to validate.
 * @returns `true` if the email matches the expected format, `false` otherwise.
 */
export const isValidEmail = (email: string) => validEmailRegex.test(email);

/**
 * Subscription types that are eligible for the "Invite Teammates" feature.
 */
const ALLOWED_SUBSCRIPTION_LIST = [
    SubscriptionType.FREE_TRIAL,
    SubscriptionType.TEAMS_EDITION,
    SubscriptionType.ESSENTIALS_EDITION,
    SubscriptionType.DEVELOPER_EDITION,
];

/**
 * Determines whether the "Invite Teammates" feature is enabled for the
 * current user based on their subscription type.
 *
 * The feature is available only for Free Trial, Teams Edition,
 * Essentials Edition, and Developer Edition subscriptions.
 *
 * @returns `true` if the user's subscription allows inviting teammates,
 *          `false` otherwise.
 */
export const isInviteTeammatesEnabled = (): boolean => {
    const userSubscription = getSubscriptionType();
    return ALLOWED_SUBSCRIPTION_LIST.includes(userSubscription);
};
